import Window, { WindowProps } from 'components/Window';
import { DragSourceMonitor, useDrag } from 'react-dnd';

interface DraggableWindowProps extends WindowProps {
    top: number,
    left: number,
    width?: number,
    index: string,
    type?: string,
    closable?: boolean,
    onDragEnd?: (
      draggedItem : {index: string},
      monitor : DragSourceMonitor<{index: string}, unknown>) => void,
    onClose?: () => void
  }

function DraggableWindow(props : DraggableWindowProps) {
  const {
    index, onDragEnd, top, left, width, type = 'WINDOW', className, ...rest
  } = props;
  const [collectedStyles, dragRef] = useDrag(
    () => ({
      type,
      item: { index },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1,
        top: `${top}px`,
        left: `${left}px`,
        width: width ? `${width}px` : 'auto',
        zIndex: 2,
      }),
      end(draggedItem, monitor) {
        if (onDragEnd) {
          const m = monitor.getDropResult() as {top: number, left: number};
          if (top + m.top <= window.innerHeight * 0.8) {
            onDragEnd(draggedItem, monitor);
          }
        }
      },
    }),
    [index, onDragEnd],
  );
  return (
    <div
      ref={dragRef}
      style={{
        ...collectedStyles, position: 'absolute', maxHeight: `calc(80vh - ${top}px)`, overflowY: 'scroll', height: '400px',
      }}
      className={className}
    >
      <Window {...rest} style={{ width: '90%' }} />
    </div>
  );
}

export default DraggableWindow;
